// eslint-disable-next-line no-restricted-imports
import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";
import {
  HOST_BASE_PATH,
  PROTOCOL,
  stringifyParams
} from "rivals/services/base";
import { PATHS } from "rivals/shared/constants";
import { redirectToGuce } from "rivals/shared/utils/routes";
import { RedirectOptions } from "./types";

function useRedirect({
  isAuthenticated,
  isSubscribed,
  referralUrlParams,
  registrationError,
  selectedSite,
  setIsRedirecting,
  submitClicked,
  redirectURI,
  user
}: RedirectOptions): void {
  const router = useRouter();

  const redirectAfterSubmission = useCallback(() => {
    setIsRedirecting(true);

    if (redirectURI && !registrationError) {
      redirectToGuce(redirectURI);
      return;
    }

    const subdomain = selectedSite?.subdomain.toLowerCase();
    const origin =
      subdomain === "rivals"
        ? `${PROTOCOL}${HOST_BASE_PATH}`
        : `${PROTOCOL}${subdomain}.${HOST_BASE_PATH}`;

    if (!registrationError) {
      redirectToGuce(`${origin}${PATHS.LANDING_PAGE}`);
      return;
    }

    if (!registrationError?.base) {
      window.location.assign(`${origin}${PATHS.NEW_SUBSCRIPTION}`);
      return;
    }

    const searchParams = new URLSearchParams({
      registrationError: registrationError.base
    }).toString();
    const destination = `${origin}${PATHS.NEW_SUBSCRIPTION}?${searchParams}`;
    window.location.assign(destination);
  }, [redirectURI, registrationError, selectedSite, setIsRedirecting]);

  const redirectAlreadyRegisteredUser = useCallback(() => {
    if (isSubscribed || !referralUrlParams) {
      router.push(PATHS.SUBSCRIPTIONS);
    } else {
      const query = referralUrlParams ? stringifyParams(referralUrlParams) : "";
      window.location.assign(`${PATHS.NEW_SUBSCRIPTION}${query}`);
    }
  }, [isSubscribed, referralUrlParams, router]);

  useEffect(() => {
    if (isAuthenticated) {
      if (submitClicked) {
        redirectAfterSubmission();
      } else if (user) {
        redirectAlreadyRegisteredUser();
      }
    }
  }, [
    isAuthenticated,
    redirectAfterSubmission,
    redirectAlreadyRegisteredUser,
    submitClicked,
    user
  ]);
}

export default useRedirect;
